<!-- <div #recaptcha></div> -->
<re-captcha
#captchaRef="reCaptcha"
  (resolved)="resolved($event)"
  (error)="onError($event)"
  errorMode="handled"
  siteKey="{{googleSiteKey}}"
  size="invisible"
></re-captcha>
